<template>
  <v-container class="step" id="emulsion-section">
    <v-row justify="center" class="full-height">
      <v-col class="s8-container">
        <div class="s8-title"
          data-aos="zoom-out"
          data-aos-delay="0"
          data-aos-duration="2000"
          data-aos-mirror="true"
          data-aos-once="false"
        >
          <p><span class="mr-4 sharp-number">#2</span><span id="s8-main-title">Re.NB PURE RADIANT REVIVAL EMULSION</span></p>
          <p id="s8-sub-title">{{$t("_s8_txt_1")}}</p>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {}
</script>

<style scoped>
.s8-container {
    width: 100%; /* Chiều rộng của div */
    height: 100%; /* Hoặc có thể là một giá trị cụ thể như 500px */
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
}
.img-container {
    width: 100%; /* Chiều rộng của div */
    height: 100%; /* Hoặc có thể là một giá trị cụ thể như 500px */
    display: flex;
    justify-content: center;
    align-items: center;
}
#s8-main-title {
    font-family: "BodoniModa-Bold";
    font-size: 35px;
    text-transform: uppercase;
}
#s8-sub-title {
    font-family: "BodoniModa-Italic";
    font-size: 18px;
    text-align: center;
}
.sharp-number {
  font-size: 25px;
  font-family: "BodoniModa-Italic";
}
@media (max-width: 960px) {
  .step {
    height: unset!important;
    scroll-snap-align:unset;
    margin-top: 20%;
  }
  .full-height {
    height: unset!important;
    width: 100%;
  }
  #s8-main-title {
      font-size: 1.6rem;
  }
  #s8-sub-title {
      font-size: 1.3rem;
  }
}
</style>